import React from "react"
import { NavLink } from "react-router-dom"

function RcmpLink(props) {
    const { to, children, ...oRest } = props;

    if (to && to?.substring(0, 2) === "./")
        return (
            <a href={to.slice(1)} {...oRest}>
                {children}
            </a>
        )

    if (to && /^https?:\/\//i.test(to))
        return (
            <a href={to} {...oRest}>
                {children}
            </a>
        )

    return (
        <NavLink to={to} {...oRest}>
            {children}
        </NavLink>
    );
}

export default RcmpLink;